import React, {useCallback, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {OutlinedInput} from '@material-ui/core';
import {validateCPF} from "../utils";
import FormControl from "@material-ui/core/FormControl";
import _ from "lodash";
import useValidationErrors from "../hooks/useValidationErrors";
import FormHelperText from "@material-ui/core/FormHelperText";
import {CpfNumberFormatCustom} from './shared/formatters/index';
import Button from "@material-ui/core/Button";
import {Search} from "@material-ui/icons";
import {containedButton, subtitle} from "../utils/styles";
import PropTypes from "prop-types";
import ButtonFiltro from "./ButtonFiltro";
import SituacaoContext from "../contexts/situacao";

const useStyles = makeStyles(theme => ({
    ...subtitle(theme),
    ...containedButton(theme, true, false),
    form: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing(),
        [theme.breakpoints.up('sm')]: {
            marginBottom: 0,
            flexDirection: 'row'
        }
    },
    inputContainerDiv: {
        marginBottom: theme.spacing(),
        flexGrow: 0,
        [theme.breakpoints.up('sm')]: {
            marginBottom: 0,
            marginRight: theme.spacing()
        }
    },
    buttonContainerDiv: {
        marginBottom: theme.spacing(),
        flexGrow: 0,
        [theme.breakpoints.up('sm')]: {
            paddingTop: 9,
            marginBottom: 0
        }
    },
    spaceContainerDiv: {
        [theme.breakpoints.up('sm')]: {
            flexGrow: 1
        }
    },
    filterContainerDiv: {
        flexGrow: 0,
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            alignItems: 'center'
        }
    }
}));

export default function FormConsultaNegociacao(props) {
    const {
        onSubmit
    } = props;
    const classes = useStyles();
    const [values, setValues] = useState({
        cpf: '',
        negociacao: '',
        situacao: 'N'
    });
    const {
        errors,
        setError,
        clearError,
        clearAllErrors
    } = useValidationErrors();

    const handleSubmit = useCallback(event => {
        event.preventDefault();

        let hasError = false;

        if (!_.isEmpty(values.cpf)) {
            clearError('cpf');
        } else {
            hasError = true;

            setError('cpf', 'É obrigatório');
        }

        if (validateCPF(values.cpf)) {
            clearError('cpf');
        } else {
            hasError = true;

            setError('cpf', 'CPF inválido');
        }

        if (!_.isEmpty(values.negociacao)) {
            clearError('negociacao');
        } else {
            hasError = true;

            setError('negociacao', 'É obrigatório');
        }

        if (!hasError) {
            setSituacao('N');

            onSubmit(values.cpf, values.negociacao, '');
        }
    }, [values]);

    const handleFilter = useCallback(() => {
        onSubmit(values.cpf, values.negociacao, values.situacao);
    }, [values]);

    const onChangeValue = useCallback(index => event => {
        event.persist && event.persist();

        setValues(prevValues => ({...prevValues, [index]: event.target.value}));
    }, []);

    const setSituacao = useCallback(newSituacao => {
        setValues(prevValues => ({...prevValues, situacao: newSituacao}));
    }, []);

    return (
        <>
            <form
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit}
                className={classes.form}>
                <div className={classes.inputContainerDiv}>
                    <FormControl variant="outlined" fullWidth>
                        <OutlinedInput
                            name='cpfInput'
                            type='text'
                            value={values.cpf}
                            onChange={onChangeValue('cpf')}
                            placeholder='CPF'
                            inputComponent={CpfNumberFormatCustom}
                            error={!!errors.cpf} />
                        {!!errors.cpf && (
                            <FormHelperText error>{errors.cpf}</FormHelperText>
                        )}
                    </FormControl>
                </div>
                <div className={classes.inputContainerDiv}>
                    <FormControl variant="outlined" fullWidth>
                        <OutlinedInput
                            name='negociacaoInput'
                            type='text'
                            value={values.negociacao}
                            onChange={onChangeValue('negociacao')}
                            placeholder='Número negociação'
                            inputProps={{ maxLength: 6 }}
                            error={!!errors.negociacao} />
                        {!!errors.negociacao && (
                            <FormHelperText error>{errors.negociacao}</FormHelperText>
                        )}
                    </FormControl>
                </div>
                <div className={classes.buttonContainerDiv}>
                    <Button
                        type='submit'
                        variant="contained"
                        startIcon={<Search />}
                        className={classes.containedButton}
                        onClick={handleSubmit}>
                        Consultar
                    </Button>
                </div>
                <div className={classes.spaceContainerDiv} />
                <div className={classes.filterContainerDiv}>
                    <SituacaoContext.Provider value={{situacao: values.situacao, setSituacao}}>
                        <ButtonFiltro
                            onFilter={handleFilter}
                            disabled={!values.cpf || !values.negociacao} />
                    </SituacaoContext.Provider>
                </div>
            </form>
        </>
    );
};

FormConsultaNegociacao.propTypes = {
    onSubmit: PropTypes.func.isRequired
};